enum PlaylistStyles {
  Regular = 0,
  LongFormArticle = 1
}

export default PlaylistStyles;
